<template>
  <v-card
    class="wallet-detail-card"
    color="grey lighten-2"
    flat
  >
    <!-- WALLET DETAILS START -->
    <v-card>
      <v-card-title class="toolbar primary white--text title">
        <v-icon
          dark
          color="white"
          class="mr-2"
        >
          account_balance_wallet
        </v-icon>
        Wallet detail: {{ id }}
        <v-spacer />
        <template
          v-if="wallet"
          class="pa-2"
        >
          <v-tooltip
            v-for="tag in wallet.tags"
            :key="tag.name"
            top
          >
            <template v-slot:activator="{ on }">
              <v-chip
                dark
                class="white--text"
                outline
                small
                v-on="on"
              >
                {{ tag.name }}: {{ tag.value }}
              </v-chip>
            </template>
            <span>
              {{ tag }}
            </span>
          </v-tooltip>
        </template>
      </v-card-title>
      <v-progress-linear
        v-if="loading"
        :indeterminate="true"
        class="ma-0"
      />
      <v-alert
        v-if="error"
        type="error"
      >
        {{ error }}
      </v-alert>
      <v-card-text>
        <v-layout
          wrap
          class="pa-0"
        >
          <v-flex
            v-for="item in filterWalletItems(wallet)"
            :key="item.text"
            class="pa-2"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-text-field
                    :label="item.text"
                    :value="wallet[item.value]"
                    readonly
                    hide-details
                  />
                </span>
              </template>
              <span>
                field: {{ item.value }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
      <!-- WALLET DETAILS END -->
      <template v-if="balances && balances.length > 0">
        <v-card-title class="toolbar grey lighten-4 title">
          <v-icon class="pr-2">
            business
          </v-icon>
          Balances
        </v-card-title>
        <!-- BALANCES TABLE START -->
        <v-data-table
          :headers="getObjectHeaders(balances[0])"
          :items="balances"
          hide-actions
        >
          <template
            slot="headerCell"
            slot-scope="props"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ props.header.text }}
                </span>
              </template>
              <span>
                {{ props.header.value }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <tr>
              <td
                v-for="(item,key) in props.item"
                :key="key"
              >
                {{ item }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <!-- BALANCES TABLE END -->
      </template>
    </v-card>
    <!-- USER DETAILS START -->
    <UserDetailCard
      v-if="wallet && wallet.userId"
      :user-id="wallet.userId"
    />
    <!-- USER DETAILS END -->
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import UserDetailCard from '@/components/shared/vault/UserDetailCard';

export default {
  name: 'WalletDetailCard',
  components: {
    UserDetailCard,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      wallet: null,
      balances: null,
      error: null,
    };
  },
  computed: {

  },
  async mounted() {
    this.loading = true;
    try {
      await this.getWallet();
      await this.getBalances(this.wallet.userId, this.wallet.wallet);
    } catch (err) {
      this.error = err;
    }
    this.loading = false;
  },
  methods: {
    ...mapActions([
      'fetchWallet',
      'getVaultWalletBalances',
    ]),
    async getWallet() {
      const result = (await this.fetchWallet(this.id))
        .find(item => item.wallet === this.id);
      this.wallet = {
        ...result,
      };

      return this.wallet;
    },
    async getBalances(userId, wallet) {
      this.balances = (await this.getVaultWalletBalances({ userId, wallet }));

      return this.balances;
    },
    filterWalletItems(wallet) {
      return this.getObjectHeaders(wallet).filter(item => item.text !== 'Tags' && item.text !== 'User Status');
    },
    getObjectHeaders(item) {
      const itemFields = { ...item };

      return Object.keys(itemFields)
        .map(key => ({ text: _.startCase(key), value: key, sortable: true }));
    },
  },
};
</script>
<style lang="scss">
.wallet-detail-card {
  padding: 32px;
  .v-card__title {
    padding: 16px 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/vault/WalletDetailCard.vue